import React, { useEffect, useState } from "react";
import { logResponse } from "../utils/logger";
import { fetchGetOrders } from "../api";
import iconStatus from "../assets/img/icon_status.svg";
import itemZakuro from "../assets/img/item_zakuro.png";
import itemDx from "../assets/img/item_dx.png";
import itemBifi from "../assets/img/item_bifi.png";
import itemJulee from "../assets/img/item_julee.png";
import itemJuleeFive from "../assets/img/item_julee_five.png";
import itemZpreg from "../assets/img/item_zpreg.png";
import itemFiber from "../assets/img/item_fiber.png";
import itemPururun from "../assets/img/item_pururun.png";
import itemMiniDx from "../assets/img/item_mini_dx.png";
import itemMiniZakuro from "../assets/img/item_mini_zakuro.png";
import itemMiniZpreg from "../assets/img/item_mini_zpreg.png";
import itemSample from "../assets/img/pic_item_sample.png";
import iconChange from "../assets/img/icon_change.svg";

const getProductUnit = (productName) => {
  if (productName.includes("ジュレ") && productName.includes("5包入り")) return "袋";
  if (productName.includes("ジュレ")) return "箱";
  if (productName.includes("ビフィずっと")) return "袋";
  if (productName.includes("山野草ファイバー")) return "袋";
  if (productName.includes("ぷるるん酵素")) return "袋";
  return "本";
};

const getProductImage = (productName) => {
  // 複合キーワード（ミニボトル×商品）を先に判定
  if (productName.includes("ミニボトル") && productName.includes("ブルーベリー")) return itemMiniDx;
  if (productName.includes("ミニボトル") && productName.includes("若榴da檸檬")) return itemMiniZakuro;
  if (productName.includes("ミニボトル") && productName.includes("ZAKURO")) return itemMiniZpreg;
  if (productName.includes("ジュレ") && productName.includes("5包入り")) return itemJuleeFive;
  // 単一キーワード（ジュレは「若榴da檸檬」を含むため先に判定）
  if (productName.includes("ブルーベリー")) return itemDx;
  if (productName.includes("ジュレ")) return itemJulee;
  if (productName.includes("若榴da檸檬")) return itemZakuro;
  if (productName.includes("ビフィずっと")) return itemBifi;
  if (productName.includes("ZAKURO")) return itemZpreg;
  if (productName.includes("山野草ファイバー")) return itemFiber;
  if (productName.includes("ぷるるん酵素")) return itemPururun;
  return itemSample;
};

const Order = () => {
  const [orders, setOrders] = useState([]);

  // 注文データを order_number ごとにグループ化
  const groupOrdersByOrderNumber = (orders) => {
    const grouped = {};

    orders
      //.filter((item) => item.order_type !== "返品") // 返品除外する場合はコメントを外す
      .forEach((item) => {
        const key = item.order_number;
        if (!grouped[key]) {
          grouped[key] = {
            order_number: key,
            order_date: item.order_date,
            scheduled_shipping_date: item.scheduled_shipping_date,
            shipping_date: item.shipping_date,
            delivery_date: item.delivery_date,
            tracking_number: item.tracking_number,
            billing_amount: item.billing_amount,
            is_unpaid: item.is_unpaid,
            payment_method_name: item.payment_method_name,
            recipient_name: item.recipient_name,
            recipient_postal_code: item.recipient_postal_code,
            recipient_address: item.recipient_address,
            recipient_prefecture_name: item.recipient_prefecture_name,
            recipient_municipality_name: item.recipient_municipality_name,
            recipient_town_name: item.recipient_town_name,
            recipient_address_detail_1: item.recipient_address_detail_1,
            recipient_address_detail_2: item.recipient_address_detail_2,
            items: [],
          };
        }
        grouped[key].items.push(item);
      });

    return Object.values(grouped);
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    fetchGetOrders(token).then((data) => {
      logResponse("token:", token);
      logResponse("res:", data);

      const grouped = groupOrdersByOrderNumber(data);

      // 並び替え処理
      const sorted = grouped.sort((a, b) => {
        // 出荷予定日が無い注文はInvalid Date→NaN比較で順序が不定になるため0扱いで安定させる
        return new Date(b.scheduled_shipping_date || 0) - new Date(a.scheduled_shipping_date || 0);
      });
      setOrders(sorted);
    });
  }, []);

  return (
    <>
      <section className="section order-section">
        <h2 className="section-title">
          <i>
            <img src={iconStatus} alt="" />
          </i>
          ご注文状況
        </h2>

        <div className="order-group group-wrapper">
          {orders.map((order, index) => {
            const isReturn = order.items.some(item => item.order_type === "返品");

            return (
            <div className="order" data-no={order.order_number} key={order.order_number}>
              <div className="order-status flex middle between">
                <div className="order-info flex middle left">
                  <h3 className="date">
                    {isReturn
                      ? (order.items[0].requested_delivery_date
                        ? `${order.items[0].requested_delivery_date} 返品受付`
                        : "返品受付")
                      : order.items[0]?.delivery_service_name === "配送なし"
                        ? "配送なし"
                        : (order.items[0].requested_delivery_date
                          ? `${order.items[0].requested_delivery_date} 到着予定`
                          : "お届け日未定")}
                  </h3>
                  {order.is_unpaid === 1 && (
                    <span className="status unpaid">
                      未入金
                    </span>
                  )}
                  {isReturn && (
                    <span className={`status ${order.delivery_date ? "returned-done" : "returned"}`}>
                      {order.delivery_date ? "返品済" : "返品"}
                    </span>
                  )}
                </div>
                {order.order_number && (
                  <div className="order-no">
                    {isReturn ? (
                      <>
                        <div>返品番号: {order.order_number}</div>
                        {order.tracking_number && (
                          <div style={{ fontSize: "11px" }}>
                            ※受注番号：{order.tracking_number}
                          </div>
                        )}
                      </>
                    ) : (
                      <>受注番号: {order.order_number}</>
                    )}
                  </div>
                )}
              </div>

              {order.items.map((item, i) => (
                <div className="item" key={i}>
                  <div className="flex">
                    <div className="image">
                      <img src={getProductImage(item.product_name)} alt={item.product_name} />
                    </div>
                    <div className="info">
                      <ul className="item-info-list">
                        <li>
                          {item.product_name}：{item.quantity}{getProductUnit(item.product_name)}
                        </li>
                        {item.used_point > 0 && ( <li>ﾎﾟｲﾝﾄ値引：{item.used_point}円</li> )}
                      </ul>
                    </div>
                  </div>

                  {/* 商品が最後でない場合のみ区切り線を表示 */}
                  {i < order.items.length - 1 && (
                    <svg className="item-separate" width="100%" height="10">
                      <line
                        x1="0"
                        y1="5"
                        x2="100%"
                        y2="5"
                        stroke="#56331f"
                        strokeWidth="1"
                        strokeDasharray="10, 5"
                      />
                    </svg>
                  )}
                </div>
              ))}
              <div className="order-detail">
                {isReturn ? (
                  /* ▼ 返品の場合：返却済み表示、送り状No非表示 */
                  order.delivery_date && (
                    <p className="date">{order.delivery_date} に返品済</p>
                  )
                ) : (
                  /* ▼ 通常注文の場合 */
                  <>
                    {order.delivery_date && (
                      <p className="date">{order.delivery_date} にお届け済み</p>
                    )}
                    {order.items[0]?.delivery_service_name !== "配送なし" && (
                    <p className="no">
                      お問合せ送り状No.{" "}
                      {order.tracking_number ? (() => {
                        const shippingDate = new Date(order.shipping_date);
                        const today = new Date();
                        const diffDays = Math.floor((today - shippingDate) / (1000 * 60 * 60 * 24));
                        const isLinkAllowed = diffDays < 60;

                        const trackingUrl = (() => {
                          const service = order.items[0]?.delivery_service_name;
                          const number = order.tracking_number;
                          if (service === "佐川急便" || service === "佐川代引") {
                            return `https://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=${number}`;
                          }
                          if (service === "ヤマト宅急便" || service === "ヤマトコレクト") {
                            return `https://member.kms.kuronekoyamato.co.jp/parcel/detail?pno=${number}`;
                          }
                          if (service === "ゆうパック" || service === "ゆうパック代引" || service === "ゆうパケット") {
                            return `https://trackings.post.japanpost.jp/services/srv/search/?requestNo1=${number}&search.x=0&search.y=0`;
                          }
                          return null;
                        })();

                        if (trackingUrl && isLinkAllowed) {
                          return (
                            <a
                              className="underline"
                              href={trackingUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {order.tracking_number}
                            </a>
                          );
                        } else {
                          return <span>{order.tracking_number}</span>;
                        }
                      })() : (
                        <span>未登録</span>
                      )}
                    </p>
                    )}
                  </>
                )}

{order.items.some(it => !it.shipping_date) && (
  <div className="change-group">
    <i>
      <img src={iconChange} alt="" />
    </i>
    <a
      href={`/contact?type=04.お届け内容の変更&content=${encodeURIComponent(
        `
【ご注文の商品一覧】
${order.items
  .map(
    (it) => `
商品名：${it.product_name}
数量：${it.quantity}${getProductUnit(it.product_name)}
${it.used_point > 0 ? `ポイント値引：${it.used_point}円` : ""}
`
  )
  .join("")}
【ご注文情報】

受注番号：${order.order_number}
注文日：${order.order_date}
お届け予定日：${order.items[0].requested_delivery_date || "未定"}
お届け先：${order.recipient_name}
住所：〒${order.recipient_postal_code}
${order.recipient_prefecture_name}${order.recipient_municipality_name}${order.recipient_town_name}
${order.recipient_address_detail_1}${order.recipient_address_detail_2}

商品合計：${(order.billing_amount ?? 0).toLocaleString()}円（税込）
支払い方法：${order.payment_method_name}

-------------------------------------------
上記、お届け内容の変更を希望します
        `
      )}`}
      className="underline bold"
    >
      お届け内容の変更
    </a>
  </div>
)}

{/* ▼ 出荷予定日が当日の場合の注意メッセージ（返品・配送なしは除外） */}
{!isReturn && order.items[0]?.delivery_service_name !== "配送なし" && (() => {
  // toISOString()はUTC日付＝JST 0:00〜8:59は前日になるため、ローカル日付で判定する
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const ssd = order.scheduled_shipping_date?.slice(0, 10);
  return ssd === today;
})() && (
  <p style={{ color: "red", fontWeight: "bold", fontSize: "13px", marginTop: "8px" }}>
    ※出荷予定日が本日となっております。<br />お届け内容を変更されたい場合は、0120-41-8504へご連絡ください。
  </p>
)}

                <p className="amount" style={isReturn ? { color: "#cc0000", fontWeight: "bold" } : {}}>
                  金額：{(order.billing_amount ?? 0).toLocaleString()}円(税込)
                </p>
              </div>
            </div>
          );
          })}
        </div>
      </section>

      <div className="btn-orange-2 fixed">
        <a href="/contact?type=04.お届け内容の変更">変更・問合せページはこちら ＞</a>
      </div>
    </>
  );
};

export default Order;
